<template>
  <div v-if="valid" class="flex-row align-items-center" style="margin: 8px 0;">
    <audio :src="this.url" controls></audio>
    <PinyinPreview class="flex1 audio-caption" style="padding-left:10px;" :text="caption" :pinyin="captionPinyin" v-if="caption"></PinyinPreview>
  </div>
</template>

<script>
import utils from './../js/utils'
import PinyinPreview from '@/components/PinyinPreview'

export default {
  name: 'AudioView',
  props: {
    src: String,
    caption: String,
    captionPinyin: String,
  },
  components: { PinyinPreview },
  data() {
    return {}
  },
  computed: {
    url() {
      return utils.url(this.src)
    },
    valid() {
      return this.src || this.caption;
    }
  }
}
</script>
